import { useLayout } from 'stores/LayoutStore'
import { observer } from 'mobx-react-lite'
import { PropsWithChildren } from 'react'
import Styles from './PostPreviewContainer.module.scss'

export const PostPreviewContainer = observer(({ children }: PropsWithChildren) => {
  const layout = useLayout()

  return (
    <div className={Styles.container} ref={(node) => layout.setPostPreview(node)}>
      {children}
    </div>
  )
})
